import React from "react";
import PropTypes from "prop-types";
import FileIcon from "utils/iconHelper";
import { ReactComponent as DeleteIcon } from "images/documents/deleteIcon.svg";
import { ReactComponent as DownloadIcon } from "images/documents/downloadIcon.svg";

function FileNameWithIcon({
  fileName,
  showHover = false,
  onDeleteHandler = () => {},
  onDownloadHandler = () => {},
  CustomButton = () => {},
  withDownload = true,
  withDelete = true,
  withoutBorder = true,
  withOutIcon = false,
  clickableLink = false,
}) {
  const onDelete = () => {
    onDeleteHandler();
  };
  const onDownload = () => {
    onDownloadHandler();
  };
  return (
    <div
      className={`flex items-start content-start gap-y-[30px] gap-x-0 flex-wrap cursor-pointer ${
        withoutBorder ? "" : "border-b border-[#E4E4E7]"
      } 
 ${showHover ? "group" : ""} `}
    >
      <div className="flex h-10 items-center gap-4">
        <div className="flex w-[249px] items-center gap-[5px]">
          {withOutIcon ? null : (
            <div className="flex w-[20px] justify-center items-center gap-[10px] shrink-0">
              <span className="w-[17px] h-[20px] flex-shrink-0 aspect-[17/20]">
                <FileIcon fileName={fileName} />
              </span>
            </div>
          )}
          {clickableLink ? (
            <a
              className={`line-clamp-1 flex-1 overflow-hidden text-ellipsis text-[16px] leading-[24px] font-medium text-[#1D1B22] font-[General_Sans] ${
                showHover ? "group-hover:text-[#4985B3]" : ""
              }`}
              href={
                fileName.startsWith("http://") ||
                fileName.startsWith("https://")
                  ? fileName
                  : `https://${fileName}`
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {fileName}
            </a>
          ) : (
            <p
              className={`line-clamp-1 flex-1 overflow-hidden text-ellipsis text-[16px] leading-[24px] font-medium text-[#1D1B22] font-[General_Sans] ${
                showHover ? "group-hover:text-[#4985B3]" : ""
              }`}
            >
              {fileName}
            </p>
          )}
        </div>
      </div>
      <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 ">
        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 ">
          <div className="flex w-[40px] h-[40px] px-[16px] py-[14px] justify-center items-center gap-2 rounded-[6px]">
            {withDownload && (
              <span
                className="flex w-6 h-6 justify-center items-center shrink-0"
                onClick={() => {
                  onDownload();
                }}
              >
                <DownloadIcon />
              </span>
            )}
            {withDelete && (
              <span
                className="flex w-6 h-6 justify-center items-center shrink-0"
                onClick={onDelete}
              >
                <DeleteIcon />
              </span>
            )}
            {CustomButton && CustomButton}
          </div>
        </div>
      </div>
    </div>
  );
}

FileNameWithIcon.propTypes = {
  fileName: PropTypes.string.isRequired,
  showHover: PropTypes.bool,
  onDelete: PropTypes.func,
  onDownload: PropTypes.func,
  withDownload: PropTypes.bool,
  withDelete: PropTypes.bool,
};

export default FileNameWithIcon;
